import React from "react";
import { useSelector } from "react-redux";
import EditorLoginGate from "../components/EditorLoginGate";
import StudioWorkspace from "../mockup-studio/StudioWorkspace";

/**
 * /multi-mockup-design-editor: the editor without a starting listing; add up
 * to 10 mockups from My mockups or Discover and place designs on all of them.
 */
const MultiMockupDesignEditor = () => {
  const { role, isLoggedIn, userid } = useSelector((state) => state.auth);
  if ((!isLoggedIn || !userid) && role !== "A") return <EditorLoginGate title="Multi-mockup design" />;
  return <StudioWorkspace title="Multi-mockup design" />;
};

export default MultiMockupDesignEditor;
